import { render } from "./CompanyManagement.vue?vue&type=template&id=1cf7154a&scoped=true"
import script from "./CompanyManagement.vue?vue&type=script&lang=js"
export * from "./CompanyManagement.vue?vue&type=script&lang=js"

import "./CompanyManagement.vue?vue&type=style&index=0&id=1cf7154a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf7154a"]])

export default __exports__